import { render, staticRenderFns } from "./contract-info-content.component.vue?vue&type=template&id=668c3060&scoped=true&"
import script from "./contract-info-content.component.vue?vue&type=script&lang=ts&"
export * from "./contract-info-content.component.vue?vue&type=script&lang=ts&"
import style0 from "./contract-info-content.component.vue?vue&type=style&index=0&id=668c3060&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "668c3060",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCol,VForm,VIcon,VRow,VSwitch,VTextField,VTooltip})
